
import store from '@/store'
import ApiClient from '@/common/api'

export default
  created: () ->
    api = new ApiClient()
    await api.get('/customs_broker/login/logout')
    location.href = '/partner'
